import React, { useRef } from "react";
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import CustomImage from "../CustomImage";
import Card from "react-bootstrap/Card";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface Props {
  title: string;
  scholarshipData: any;
  sectionBgColor: string;
}

const EduFairStudentScholarship: React.FC<Props> = ({ title, scholarshipData, sectionBgColor }) => {
  const sliderRef = useRef<Slider>(null);
  const settings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      }
    ]
  };
  return (
    <div id="top-scholarship" className={styles.topScholarship} style={{ background: sectionBgColor || '#EEF2FB' }}>
      <Container>
        <Row>
          <div className={styles.heading}>
            <h2>{title}</h2>
          </div>
        </Row>
        <Row>
          <div className={styles.stuSchSlider}>
            <Slider {...settings} className={styles.slider} ref={sliderRef}>
              {
                scholarshipData?.length > 0 &&
                scholarshipData.map((scholarship: any, index: number) => {
                  return (
                    <div className={styles.sliderCardDiv} key={index}>
                      <Card className={styles.cardCust}>
                        <div className={styles.studeImgDiv}>
                          <CustomImage src={scholarship?.studentImageUrl} width={160} height={160} className={styles.cardImg} alt="University Akshay Singh Chouhan" />
                        </div>
                        <Card.Body className={styles.cardBody}>
                          <div className={styles.stuName}> <h4>{scholarship?.studentName}</h4> </div>
                          {
                            scholarship?.points?.length > 0 &&
                            scholarship?.points.map((point: any, index: number) => {
                              return (
                                <div className={styles.StdDetail}>
                                  <div> <span style={index === 3 ? { color: "#1321C5" } : {}}>{point?.label}</span> </div>
                                  <div style={index === 3 ? { color: "#1321C5" } : {}}><p>{point?.value}</p> </div>
                                </div>
                              )
                            })
                          }
                        </Card.Body>
                      </Card>
                    </div>
                  )
                })
              }
            </Slider>
          </div>
        </Row>

      </Container>
    </div>
  )
}

export default EduFairStudentScholarship;